import type * as Types from '../../types';

import gql from 'graphql-tag';
import type * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/client';
export type GetCertificateOfStudyQueryVariables = Types.Exact<{
  studentId: Types.Scalars['Int'];
}>;


export type GetCertificateOfStudyQuery = { certificateOfStudy?: Types.Maybe<{ __typename?: 'DownloadFile', fileName?: Types.Maybe<string>, fileContent?: Types.Maybe<Array<any>>, fileContentBase64?: Types.Maybe<string>, fileType?: Types.Maybe<string> }> };


export const GetCertificateOfStudyDocument = gql`
    query getCertificateOfStudy($studentId: Int!) {
  certificateOfStudy(studentId: $studentId) {
    fileName
    fileContent
    fileContentBase64
    fileType
  }
}
    `;

/**
 * __useGetCertificateOfStudyQuery__
 *
 * To run a query within a React component, call `useGetCertificateOfStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateOfStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificateOfStudyQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetCertificateOfStudyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCertificateOfStudyQuery, GetCertificateOfStudyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCertificateOfStudyQuery, GetCertificateOfStudyQueryVariables>(GetCertificateOfStudyDocument, baseOptions);
      }
export function useGetCertificateOfStudyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCertificateOfStudyQuery, GetCertificateOfStudyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCertificateOfStudyQuery, GetCertificateOfStudyQueryVariables>(GetCertificateOfStudyDocument, baseOptions);
        }
export type GetCertificateOfStudyQueryHookResult = ReturnType<typeof useGetCertificateOfStudyQuery>;
export type GetCertificateOfStudyLazyQueryHookResult = ReturnType<typeof useGetCertificateOfStudyLazyQuery>;
export type GetCertificateOfStudyQueryResult = ApolloReactCommon.QueryResult<GetCertificateOfStudyQuery, GetCertificateOfStudyQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
